<template>
  <v-dialog
      v-model="dialog"
      v-bind:disabled="!hasLabel"
      persistent
      max-height="680"
      scrollable
      :fullscreen="$vuetify.display.xs"
      :width="$vuetify.display.smAndUp ? 600 : 'auto'"
      style="z-index: 1100 !important;"
    >

    <template v-slot:activator="{ props }">
      <div v-bind="props" data-cy="tenantLabels-deleteLabel-activator">
        <slot></slot>
      </div>
    </template>

    <div class="vb-dialog vb-dialog-danger">
      <v-card v-cloak data-cy="dialog-deleteLabel-modal">
        <v-card-title class="d-flex justify-space-between mb-2">
          {{$t('routes.labels.deleteLabel')}}

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <p class="mt-4">
           {{$t('routes.labels.confirmDeleteLabel')}}
          </p>

          <p class="font-weight-bold mt-4">
            {{ label.content }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-btn class="ml-auto bg-red-darken-3" color="btnOk" elevation=0 @click="deleteLabel" data-cy="dialog-deleteLabel-ok">
            {{$t('common.delete')}}
          </v-btn>
          <v-btn variant="text" @click="dialog = false" class="btnCancel" data-cy="dialog-deleteLabel-false">
            {{$t('common.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useLabelStore } from '@/stores/LabelStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ["labelUpdated"],
  mixins: [DialogActionKeys],
  name: "DeleteLabelDialog",

  props: {
    label: {
      type: Object,
      required: true,
    }
  },

  data: function() {
    return {
      dialog: false,
    }
  },

  mounted() {
  },

  methods: {
    deleteLabel: function() {
      const payload = {
        labelId: this.label.id,
        accessPointId: this.accessPointId,
      };

      const labelStore = useLabelStore();
      labelStore.deleteLabel(payload)
        .then(() => {
          this.$emit('labelUpdated', this.label.categoryid);

          this.dialog = false;
        })
        .catch((error) => {
          const apiError = error?.response?.data?.error?.message;

          if (apiError) {
            this.$showMessage(apiError, { type: 'error' });
          } else {
            console.log(apiError);
          }
        });
    },
  },

  computed: {
    accessPointId() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    hasLabel() {
      return !!(this.label && this.label.id);
    }
  }
};
</script>

<style>

</style>
